import { Offer } from '@wwt/entities/search-response'

export const extractOfferFromOffers = (
	offers: Offer[],
	offerId: string | null
) => {
	return offers.find(offer => offer.IDs.nonPersistingOfferId === offerId)
}
